<template>
    <div class="text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="aside-box" v-else-if="highlights.length">
        <strong class="h2 text-uppercase">Match highlights</strong>
        <div class="row post-holder">
            <div class="post col-sm-6 col-md-12" v-for="highlight in highlights" :key="highlight.id">
                <a href="javascript:;">
                    <span v-html="highlight.highlight"></span>
                </a>
                <div class="descrip">
                    <h2>
                        <router-link :to="{ name: 'matchDetail.Scorecard', params: { match: highlight.match.slug } }">
                            {{ highlight.title }}
                    </router-link>
                </h2>
                <time class="time" :datetime="highlight.created_at | formatDate('YYYY-MM-DD')">
                      {{ highlight.created_at | timeElaped }}
            </time>
        </div>
    </div>
</div>
</div>
</template>

<script>
    export default {
        name: 'matchHighlights',

        data() {
            return {
                highlights: []
            }
        },

        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return
                  let videos = []
               this.highlights.forEach((video) => {
                videos.push(
                        {
                            "@type": "VideoObject",
                            "name": video.title,
                            "description": video.title,
                            "thumbnailUrl": [
                                process.env.BASE_URL + 'public/images/logo1280x720.png'
                            ],
                            "uploadDate": video.created_at,
                            "contentUrl": process.env.BASE_URL,
                            "embedUrl": process.env.BASE_URL,
                        }
                )
            });
                return {
                "@context": "http://schema.org",
                "@graph": videos
            }
        },

        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        mounted() {
            this.main();
        },
        methods: {
            main() {
                return this.$axios
                        .get(this.$MATCH_HIGHLIGHTS_API.replace(':match', this.$route.params.match))
                        .then(response => {
                            this.is_data_ready = true
                            this.highlights = response.data.result.highlights || []
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            }
        }
    }
</script>
